import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

@Component({
  selector: 'app-topnav',
  templateUrl: './topnav.component.html',
  styleUrls: ['./topnav.component.css']
})
export class TopnavComponent implements OnInit{

  isHomeRoute: boolean = false
  user :{[key:string]:string;}  = {}
  walletBalance: { [key: string]: any } = {};
  walBalance = true;
  unitBalance = false;

  constructor(
    private r: Router
  ) {
    this.r.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe((event: any ) => {
      this.isHomeRoute = (
        event.url === '/' || 
        event.url === '/splash' || 
        event.url === '/signin' || 
        event.url === '/signup' || 
        event.url === '/forgetPassword' || 
        event.url === '/get-qoute' || 
        event.url === '/welcome')
    });
    this.user = JSON.parse(localStorage.getItem('user')!)
  }


  ngOnInit(): void {
    this.walletBalance = JSON.parse(localStorage.getItem('wallet')!);

    if (this.r.url.includes('dashboard')) {
      console.log('here in the dashboard')
      sessionStorage.setItem('reloaded', 'true');
      setTimeout(() => {
        location.reload();
      }, 1000);
    }

    if(this.user['role'] === 'staff'){
      this.walBalance = false;
      this.unitBalance = true;
    }else if(this.user['role'] === 'broker'){
      this.unitBalance = true;
    }
  }

  hide = true;
  eye() {
    this.hide = !this.hide;
  }
  

}
